import { useQueryClient } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'

import { useAppSelector } from '@/redux/hooks'
import { AssistantActions } from '@/redux/reducers/assistant'

import {
  useThreadsServiceDeleteV1IndividualsByIndividualIdThreadsByThreadId,
} from '../client/queries'
import {
  useThreadsServiceGetV1IndividualsByIndividualIdThreadsKey,
} from '../client/queries/common'

export const useDeleteThread = () => {
  const queryClient = useQueryClient()
  const activeThreadId = useAppSelector(state => state.assistant.activeThreadId)
  const dispatch = useDispatch()

  return useThreadsServiceDeleteV1IndividualsByIndividualIdThreadsByThreadId({
    onSuccess: (_, { threadId }) => {
      if (threadId === activeThreadId) {
        dispatch(AssistantActions.toggleSideChat(false))
        dispatch(AssistantActions.setActiveThreadId(undefined))
      }

      queryClient.invalidateQueries({
        queryKey: [useThreadsServiceGetV1IndividualsByIndividualIdThreadsKey],
      })
    },
  })
}
